import { NgModule } from '@angular/core';
import { Error429Component } from './error-429.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { GenericAlertComponent } from '../../../../gt2/components/generic-alert/generic-alert.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';
import { AppRoutesName } from '../../../../gt2/const/AppRoutesName';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ERROR_429,
    component: Error429Component,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ERROR_429,
    component: Error429Component,
  },
  {
    path: AppRoutesName.EN.ERROR_429,
    component: Error429Component,
  },
  {
    path: AppRoutesName.FR.ERROR_429,
    component: Error429Component,
  },
];

@NgModule({
  imports: [
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    TranslateModule.forRoot(),
    GenericAlertComponent,
    RouterModule.forChild(routes),
    MatIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
  ],
  declarations: [Error429Component],
})
export class Error429Module {}
